<template>
  <div>
    <div class="title">{{ $t('lang.particulars.NetworkTraffic') }}</div>
    <network-traffic :list="list" @showDeviceDetail="showDeviceDetail"></network-traffic>
    <div v-if="!SsPsShow && list.deviceSmartcardTag != 1 && list.deviceSmartcardTag != 3" class="title">
      {{ $t('lang.particulars.wan3g1') }}
      <el-button v-if="list.deviceSoftwareVer > 'v2.4' && (smartenable.hardware_class.indexOf('SMDC') != -1)" size="mini"
        type="primary" @click="switchRecord(1)">{{ $t('lang.switchCrad.ViewChekaRecords') }}</el-button>
    </div>
    <three-wan v-if="!SsPsShow && list.deviceSmartcardTag != 1 && list.deviceSmartcardTag != 3" :wanData="wan1"
      :deviceIsconnected="deviceIsconnected"></three-wan>
    <div v-if="!SsPsShow && list.deviceHardwareType == 3 && list.deviceSmartcardTag != 2 && list.deviceSmartcardTag != 3"
      class="title">
      {{ $t('lang.particulars.wan3g2') }}
      <el-button v-if="list.deviceSoftwareVer > 'v2.4' && (smartenable.hardware_class.indexOf('SMDC') != -1)" size="mini"
        type="primary" @click="switchRecord(2)">{{ $t('lang.switchCrad.ViewChekaRecords') }}</el-button>
    </div>
    <three-wan v-if="!SsPsShow && list.deviceHardwareType == 3 && list.deviceSmartcardTag == 0" :wanData="wan2"
      :deviceIsconnected="deviceIsconnected"></three-wan>
    <div v-if="!SsPsShow && (list.deviceSmartcardTag == 1 || list.deviceSmartcardTag == 3)" class="title">
      {{ $t('lang.particulars.wan3g1Tag1') }}
      <el-button v-if="list.deviceSoftwareVer > 'v2.4' && smartenable.gwan1" size="mini" type="primary"
        @click="switchRecord(1)">{{ $t('lang.switchCrad.ViewChekaRecords') }}</el-button>
    </div>
    <three-wan v-if="!SsPsShow && (list.deviceSmartcardTag == 1 || list.deviceSmartcardTag == 3)"
      :deviceSmartcardTag="list.deviceSmartcardTag" :wanData="wan1" :deviceIsconnected="deviceIsconnected"></three-wan>
    <div
      v-if="!SsPsShow && list.deviceHardwareType == 3 && (list.deviceSmartcardTag == 2 || list.deviceSmartcardTag == 3)"
      class="title">
      {{ $t('lang.particulars.wan3g1Tag2') }}
      <el-button v-if="list.deviceSoftwareVer > 'v2.4' && smartenable.gwan2" size="mini" type="primary"
        @click="switchRecord(2)">{{ $t('lang.switchCrad.ViewChekaRecords') }}</el-button>
    </div>
    <three-wan
      v-if="!SsPsShow && list.deviceHardwareType == 3 && (list.deviceSmartcardTag == 2 || list.deviceSmartcardTag == 3)"
      :deviceSmartcardTag="list.deviceSmartcardTag" :wanData="wan1" :deviceIsconnected="deviceIsconnected"></three-wan>
    <!-- 有线广域网 -->
    <div class="title">{{ $t('lang.particulars.WAN') }}</div>
    <wirewide-network :list="list"></wirewide-network>
    <!-- 有线局域网lan -->
    <div class="title">{{ $t('lang.particulars.profile') }}</div>
    <wire-lan :list="list"></wire-lan>
    <switchCard ref="switchCard"></switchCard>
  </div>
</template>
<script>
import networkTraffic from './networkTraffic'
import wirewideNetwork from './wirewideNetwork'
import wireLan from './wireLan'
import threeWan from './3gwan'
import switchCard from './switchCard.vue'
export default {
  props: ['list', 'SsPsShow', 'smartenable'],
  components: {
    networkTraffic,
    wirewideNetwork,
    wireLan,
    threeWan,
    switchCard
  },
  data() {
    return {
      // 3wan1的数据，list数据混乱，把3gwan1和3gwan2的数据抽离封装
      wan1: {},
      wan2: {},
      // 设备连接状态
      deviceIsconnected: ''
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        console.log(this.smartenable);
        
        this.deviceIsconnected = this.list.deviceIsconnected
        // 判断是否需要展示网络标签，需要展示才对数据进行处理
        if (!this.SsPsShow) {
          this.wan1 = this.list.deviceStatusList[2] ? this.list.deviceStatusList[2] : ''
          if (this.list.deviceNetStatusList) {
            this.$set(this.wan1, 'deviceNetStatusList', this.list.deviceNetStatusList[1])
          }
          if (this.list.deviceHardwareType == 3) { // 双模双卡模式
            this.wan2 = this.list.deviceStatusList[1] ? this.list.deviceStatusList[1] : ''
            if (this.list.deviceNetStatusList) {
              this.$set(this.wan2, 'deviceNetStatusList', this.list.deviceNetStatusList[2])
            }
          } else {
            this.wan2 = ''
          }
        } else {
          this.wan1 = ''
          this.wan2 = ''
        }
        // 处理数据（wan1,wan2）
        this.handleData()
      }
    }
  },
  methods: {
    handleData() {
      if (this.wan1) {
        // 以|符号来分割是3gwan1还是3gwan2，第一个是3gwan1的数据
        let wan1Info = this.list.deviceInfo3g4g.split('|')[0]
        let wan1Arr = wan1Info.split('#')
        this.$set(this.wan1, 'IMEI', wan1Arr[0])
        this.$set(this.wan1, 'IMSI', wan1Arr[1])
        this.$set(this.wan1, 'ICCID', wan1Arr[2])
        let wan1Other = this.list.deviceInfo3g4gOther.split('|')[0]
        let wan1OtherArr = wan1Other.split('#')
        this.$set(this.wan1, 'model', wan1OtherArr[0])
        this.$set(this.wan1, 'Operator', wan1OtherArr[1])
        this.$set(this.wan1, 'supported', wan1OtherArr[2])
      }
      if (this.wan2) {
        // 以|符号来分割是3gwan1还是3gwan2，第二个是3gwan2的数据
        let wan2Info = this.list.deviceInfo3g4g.split('|')[1]
        if (!wan2Info) return
        let wan2Arr = wan2Info.split('#')
        this.$set(this.wan2, 'IMEI', wan2Arr[0])
        this.$set(this.wan2, 'IMSI', wan2Arr[1])
        this.$set(this.wan2, 'ICCID', wan2Arr[2])
        let wan2Other = this.list.deviceInfo3g4gOther.split('|')[1]
        let wan2OtherArr = wan2Other.split('#')
        this.model = wan2OtherArr[0]
        this.Operator = wan2OtherArr[1]
        this.supported = wan2OtherArr[2]
        this.$set(this.wan2, 'model', wan2OtherArr[0])
        this.$set(this.wan2, 'Operator', wan2OtherArr[1])
        this.$set(this.wan2, 'supported', wan2OtherArr[2])
      }
    },
    showDeviceDetail() {
      this.$emit('showDeviceDetail')
    },
    switchRecord(e) {
      this.$refs['switchCard'].show = true
      this.$refs['switchCard'].type = e
      this.$refs['switchCard'].deviceDid = this.list.deviceDid
    }
  },
}
</script>
<style scoped>
.title {
  margin-top: 15px;
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: bold;
}
</style>